/* eslint-disable class-methods-use-this */
import wretch from 'wretch';

export default class UclBrackets {
    constructor() {
        this.isInitialized = true;
        this.apiUrl = '/web3/config';
        this.container = document.querySelector('.ucl-brackets');

        if (!this.container) {
            this.isInitialized = false;

            return;
        }

        this.init();
    }

    async init() {
        [this.bracketsSection] = document.querySelectorAll('.ucl-brackets');
        const tableSettings = await this.getTablesSettings();
        const imageUrl = tableSettings.find((item) => item.value === 'ucl_bracket_image');
        const toDisplay = tableSettings.find((item) => item.value === 'ucl_bracket_display');
        if (imageUrl && toDisplay && toDisplay.text === 'true') {
            this.replaceUrl(imageUrl.text);
            document.querySelectorAll('.ucl-brackets')[0].style.display = 'block';
        } else {
            document.querySelectorAll('.ucl-brackets')[0].style.display = 'none';
        }
    }

    async getTablesSettings() {
        const baseUrl = window.location.origin;
        const url = `${baseUrl}${this.apiUrl}`;
        try {
            return await wretch(url)
                .get()
                .json();
        } catch (e) {
            console.error(`Error getting settinfs: ${e}`);
            return null;
        }
    }

    replaceUrl(replacement) {
        const searchString = 'uclBracketUrlPlaceholder';
        const attributesToCheck = ['src', 'data-src', 'srcset', 'data-srcset'];
        this.container.querySelectorAll('*').forEach((el) => {
            attributesToCheck.forEach((attr) => {
                if (el.hasAttribute(attr)) {
                    const value = el.getAttribute(attr);
                    if (value && value.includes(searchString)) {
                        el.setAttribute(attr, value.split(searchString).join(replacement));
                    }
                }
            });
        });
    }
}
